<template>

    <component :is="tag" class="price-value">
        {{ $filters.energeticsPrettier(value) }}
        <sub><span v-if="value >= 1000">tisíc</span> {{getText('currency')}} / rok</sub>
    </component>
        
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    props: {
        value: {
            type: Number,
            required: true,
        },
        tag: {
            type: String,
            default: 'h1',
        }
    },
    computed: mapGetters(["getText"]),
}
</script>

<style lang="scss">
.price-value {
    text-align: center;
}
</style>